import type { FC, PropsWithChildren } from 'react'

export const FullPageWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div className="flex h-dvh w-full flex-col items-center justify-center">{children}</div>
)
